import { NgModule } from '@angular/core';
import { SharedModule } from 'lib-trend-core';
import {
  ChatSharedModule,
  ChatStateModule,
  ChatStatusModule,
} from 'lib-trend-core/chat';
import { ChatAppLauncherRouteComponent } from '../chat-app-launcher/chat-app-launcher-route.component';
import { ChatBubbleHostComponent } from './chat-bubble-host.component';

/**
 * Always-mounted Internal Chat bubble (SPEC-2026-07-internal-chat, T-17/T-18;
 * SPEC-2026-09-internal-chat-pwa, T-41).
 *
 * The product's chat surface is the compact window ONLY: the saved / team / threads /
 * search panes and the full conversation view live in the chat app, and every path that
 * used to expand this window now hands the destination over to it (RF-13). This module
 * also declares the `/chat` launcher route, where a chat notification activated on a
 * browser with no chat app session lands (RF-19).
 *
 * Being eager, it is ALSO the single registration point of the NgRx `chatState` feature
 * (ChatStateModule: store + effects + socket bridge) — the FAB badge, the topbar pill and
 * the popup list consume the store on every authenticated route. ChatSharedModule brings
 * the conversation pane + composer.
 */
@NgModule({
  imports: [
    SharedModule,
    ChatStateModule,
    ChatSharedModule,
    // REQUIRED beyond <chat-status-button>: the popup's identity card opens
    // ChatStatusDialogComponent through MatDialog, and that component is
    // DECLARED in ChatStatusModule (T-21 · RF-29).
    ChatStatusModule,
  ],
  declarations: [
    ChatBubbleHostComponent,
    ChatAppLauncherRouteComponent,
  ],
  exports: [ChatBubbleHostComponent, ChatAppLauncherRouteComponent],
})
export class ChatBubbleModule { }
